import type { InvestmentState } from './types';

export const createEmptyInvestmentState = (): InvestmentState => ({
  leads: [],
  projects: [],
  theses: [],
  diligenceItems: [],
  risks: [],
  decisions: [],
  conditions: [],
  transactions: [],
  tasks: [],
  activities: [],
  followUps: [],
  investedAmount: 0,
});
